const BASE62_CHARS = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

export function encodeIdToShortCode(id: number): string {
  if (id === 0) return "0";
  let result = "";
  let num = Math.abs(Math.floor(id));
  while (num > 0) {
    result = BASE62_CHARS[num % 62] + result;
    num = Math.floor(num / 62);
  }
  return result;
}

export function decodeShortCode(code: string): number | null {
  if (!code || typeof code !== "string") return null;
  let result = 0;
  for (let i = 0; i < code.length; i++) {
    const char = code[i];
    const index = BASE62_CHARS.indexOf(char);
    if (index === -1) return null;
    result = result * 62 + index;
    if (result > Number.MAX_SAFE_INTEGER) return null;
  }
  return result;
}

export function getShortShareUrl(origin: string, id: number): string {
  const code = encodeIdToShortCode(id);
  return `${origin}/s/${code}`;
}